import React, {
  ChangeEvent,
  SyntheticEvent,
  useEffect,
  useMemo,
  useState,
} from "react";
import { useForm } from "react-hook-form";
import { Box } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { isEmpty } from "lodash";
import { useMsal } from "@azure/msal-react";

import HomeHeader from "./HomeHeader";
import { MyAccountModel } from "../../../models/MyAccount";
import {
  ReferralDetail,
  ReferralDetailsPayload,
  ReferralSearchPayload,
} from "../../../models/Referral";
import {
  ApplicationTitles,
  defaultListData,
  defaultReferralPayload,
  GetReferralListActionDispatchTypes,
  UserRole,
} from "../../../constants/HomePage";
import { getAgencyList, getAgencyListForTangoAdmin, showMessageModal } from "../../../app/common";
import { ServiceProvider } from "../../../models/ServiceProvider";
import { resetStates } from "../../../actions/Common";
import { ListOptions } from "../../../models/Master";
import AllPatientList from "../containers/AllPatientList";
import { PER_PAGE } from "../../../constants/FunctionalUtils";
import {
  bcbsTnUser,
  getCurrnetPageFullPath,
  getSessionStorage,
  getUaserPageViewPayload,
  getValue,
  length,
  Logout,
  scrollToTop,
  setSessionStorage,
} from "../../../utils";
import { AuthContainer } from "../style/style";
import Pagination from "./Pagination";
import { UserPageTrack } from "../../../models/User";
import { redirectUri } from "../../../constants/Config";
import { Bcbs_Tn_SSO_ActionDispatchTypes, getValidMessageType } from "../../../constants/User";
import { MessageType, ResponseMessages } from "../../../constants/ResponseMessage";
export interface PropsFromState {
  masterServiceProviderList: ServiceProvider[];
  loggedInUser: MyAccountModel;
  referralList: ReferralDetail[];
  referralSearchList: ReferralDetail[];
  samlResponseState: any;
  userLogoutState: any;
  refreshTokenResponseState: any
}

export interface PropsFromDispatch {
  getMasterServiceProvider: () => void;
  getReferralListByProviderId: (payload: ReferralDetailsPayload) => void;
  getReferralSearchList: (payload: ReferralSearchPayload) => void;
  resetReferralSearchList: () => void;
  getMasterServiceProviderDefault: () => void;
  postUserPageTrack: (payload: UserPageTrack) => void;
  logoutPortalApp: () => void;
}

type AllProps = PropsFromState & PropsFromDispatch;

const Home: React.FC<AllProps> = ({
  masterServiceProviderList,
  loggedInUser,
  getMasterServiceProvider,
  getReferralListByProviderId,
  referralList,
  referralSearchList,
  getReferralSearchList,
  resetReferralSearchList,
  getMasterServiceProviderDefault,
  postUserPageTrack,
  samlResponseState,
  logoutPortalApp,
  userLogoutState,
  refreshTokenResponseState
}) => {
  const [serviceProviderList, setServiceProviderList] = useState<ListOptions[]>(
    []
  );
  const [page, setPage] = useState(1);
  const [referralData, setReferralData] = useState<ReferralDetail[]>([]);
  const [listType, setListType] = useState<number>(0);
  const [agencyProvider, setAgencyProvider] =
    useState<ListOptions>(defaultListData);
  const [showAuthHistory, setShowAuthHistory] = useState<number | null>(null);

  const list =
    getValue(referralSearchList, "[0].referralId") > 0
      ? referralSearchList
      : referralList;

  const count = Math.ceil(
    list ? getValue(list, "[0].totalRows", 0) / PER_PAGE : 1 / PER_PAGE
  );

  const agencyDropdownList = useMemo(() => {
    return loggedInUser.providerPortalUser.roleType !== UserRole.TANGO_ADMIN
      ? getAgencyList(masterServiceProviderList, loggedInUser)
      : getAgencyListForTangoAdmin(masterServiceProviderList);
  }, [loggedInUser, masterServiceProviderList]);

  const methods = useForm<ReferralSearchPayload>({
    defaultValues: defaultReferralPayload,
  });

  const { handleSubmit, control, setValue, getValues } = methods;
   const { instance } = useMsal();
  const [errorModal, setErrorModal] = useState<boolean>(false);
  const [confirm, setConfirm] = useState<boolean>(false);

  useEffect(() => {
    if (confirm === true && bcbsTnUser()) {
      setErrorModal(false);
      resetStates(Bcbs_Tn_SSO_ActionDispatchTypes.BCBS_TN_SSO_RESET);
      setSessionStorage("samlToken", null);
      setSessionStorage("samlUserEmail", null);
      logoutPortalApp();
    }
  },[confirm])

   useEffect(() => {
     if (
       userLogoutState &&
       getValue(userLogoutState, "response.status") === 200
     ) {
       Logout(redirectUri, instance);
     }
   }, [userLogoutState]);

  useEffect(() => {
    getMasterServiceProvider();
    getMasterServiceProviderDefault();
    postUserPageTrack(
      getUaserPageViewPayload(
        getValidMessageType(ApplicationTitles.HOME),
        getCurrnetPageFullPath(),
        redirectUri,
        ""
      )
    );
  }, []);

  useEffect(() => {
    if (getValues("providerId") > 0) {
      if (isEmpty(getValues("searchTerm"))) {
        const payload = {
          providerId: getValues("providerId"),
          pageNo: getValues("pageNo"),
          pageSize: getValues("pageSize"),
        };
        getReferralListByProviderId(payload);
      } else {
        getReferralSearchList(getValues());
      }
    }
  }, [getValues("providerId")]);

  useEffect(() => {
    const accessToken = getValue(refreshTokenResponseState, "accessToken", "") || getValue(samlResponseState, "accessToken", "");

    if (bcbsTnUser() && accessToken.length > 0) {
      const tempAgencyList = getAgencyList(masterServiceProviderList, loggedInUser);
      setTimeout(() => {
        if (isEmpty(tempAgencyList) && tempAgencyList && tempAgencyList.length === 0
          && confirm === false && (
          masterServiceProviderList && masterServiceProviderList.length > 0 &&
          getValue(loggedInUser, 'providerPortalUser.email') !== ""
        )) {
          setErrorModal(true);
        } else {
          setErrorModal(false);
        }
      }, 300);
    }
    setServiceProviderList(agencyDropdownList);

    if (agencyDropdownList && length(agencyDropdownList)) {
      const agencyStorageData = getSessionStorage("agencyStorage");
      const matchingAgencyProvider = agencyDropdownList.find(
        (item) =>
          item.value === getValue(agencyStorageData, "value") &&
          item.label === getValue(agencyStorageData, "label"),
      );

      if (matchingAgencyProvider) {
        setValue("providerId", agencyStorageData.value);
        setAgencyProvider(agencyStorageData);
      } else {
        setValue("providerId", agencyDropdownList[0].value);
        setAgencyProvider(agencyDropdownList[0]);
        setSessionStorage("agencyStorage", agencyDropdownList[0].value);
        handleAgencyChange(
          {} as SyntheticEvent<Element, Event>,
          agencyDropdownList[0],
        );
      }
    }
  }, [agencyDropdownList]);

  useEffect(() => {
    if (getValue(referralSearchList, "[0].referralId") > 0) {
      setReferralData(referralSearchList);
    } else {
      setReferralData(referralList);
    }
  }, [referralList, referralSearchList]);

  const onSubmit = (data: ReferralSearchPayload) => {
    if (isEmpty(getValues("searchTerm"))) {
      const payload = {
        providerId: data.providerId,
        pageNo: data.pageNo,
        pageSize: data.pageSize,
      };
      getReferralListByProviderId(payload);
    } else {
      getReferralSearchList(data);
    }
  };

  const [agencyAccess, setAgencyAccess] = useState<boolean>(false);

  const handleAgencyChange = (
    _e: SyntheticEvent<Element, Event>,
    value: ListOptions
  ) => {
    setValue("searchTerm", "");
    resetReferralSearchList();
    resetStates(GetReferralListActionDispatchTypes.GET_REFERRAL_LIST_RESET);
    setPage(1);
    setShowAuthHistory(null);
    setAgencyProvider(value);
    setValue("providerId", Number(value.value));
    setValue("pageNo", 1);
    setSessionStorage("agencyStorage", value);
    setAgencyAccess(checkPriorAuthAccess(masterServiceProviderList));
    handleSubmit(onSubmit)();
    setReferralData([]);
  };

  const checkPriorAuthAccess = (masterServiceProviderList: ServiceProvider[]) => {
    const agencyStorageData = getSessionStorage("agencyStorage");
    const selectedServiceRequestId = getValue(agencyStorageData, "value")
    const selectedProvider = masterServiceProviderList && masterServiceProviderList.filter((item: ServiceProvider) => Number(item.serviceProviderId) === Number(selectedServiceRequestId))
    return selectedProvider && selectedProvider[0] !== undefined && selectedProvider[0].isPriorAuthEnable;
  }

  const handlePageChange = (_e: ChangeEvent<unknown>, page: number) => {
    setValue("pageNo", page);
    setPage(page);
    scrollToTop();
    handleSubmit(onSubmit)();
    setReferralData([]);
  };

  const priorAuthButtonVisibility = useMemo(() => {
    return (
      (loggedInUser?.providerPortalUser?.roleType === UserRole.PROVIDER_ADMIN ||
        loggedInUser?.providerPortalUser?.roleType === UserRole.TANGO_ADMIN ||
        loggedInUser?.providerPortalUser?.roleType ===
          UserRole.PROVIDER_USER) &&
          checkPriorAuthAccess(masterServiceProviderList) === true ? true : false
    );
  }, [loggedInUser, masterServiceProviderList, agencyAccess]);

  return (
    <Box>
      <Grid container>
        <Grid size={{ xs: 12 }} sx={AuthContainer}>
          <Grid size={{ xs: 12 }}>
            <HomeHeader
              control={control}
              serviceProviderList={serviceProviderList}
              handleAgencyChange={handleAgencyChange}
              agencyProvider={agencyProvider}
              setListType={setListType}
            />
          </Grid>
          <Grid size={{ xs: 12 }}>
            <AllPatientList
              control={control}
              referralData={referralData}
              setReferralData={setReferralData}
              getValues={getValues}
              showAuthHistory={showAuthHistory}
              setShowAuthHistory={setShowAuthHistory}
              resetReferralSearchList={resetReferralSearchList}
              setPage={setPage}
              setValue={setValue}
              listType={listType}
              priorAuthButtonVisibility={priorAuthButtonVisibility}
              agencyAccess={checkPriorAuthAccess(masterServiceProviderList)}
            />
          </Grid>
        </Grid>
        {getValue(referralData, "[0].referralId") > 0 && (
          <Grid size={{ xs: 12 }}>
            <Pagination
              referralData={referralData}
              handlePageChange={handlePageChange}
              count={count}
              page={page}
            />
          </Grid>
        )}
      </Grid>
      {errorModal &&
        showMessageModal(
          errorModal,
          setErrorModal,
          ResponseMessages(MessageType.NO_PROVIDERS_AVAILABLE_SSO_BCBS_TN_USER),
          setConfirm,
          true
        )}
    </Box>
  );
};

export default Home;
